// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
// consts
import { TYPE as CLIENT_TYPE, STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
// api
import Client from 'app/api/client';
// views
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import { sortString } from 'app/lib/helper';

class DropdownClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            options: [],
        };
    }

    componentDidMount() {
        Client.list()
            .then(this.onLoadClientSuccess)
            .catch(this.onLoadClientFail);
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadClientSuccess = result => {
        const showSalvus = client => (this.props.showSalvus ? true : client.type !== CLIENT_TYPE.SALVUS);
        const filter = c => this.props.filter.includes(c.status);
        let clients = result.filter(client => showSalvus(client) && filter(client)).map(client => ({
            text: client.name,
            value: client.id,
        }));
        clients.sort((a, b) => sortString(a.text, b.text));
        const options = [{ text: '-', value: null }].concat(clients);
        if (this._isMounted) {
            this.setState({
                loading: false,
                options,
            });
        }
    };

    onLoadClientFail = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                options: [],
            });
        }
    };

    render() {
        const { options, loading } = this.state;
        const { width, value, onChange, error } = this.props;
        return (
            <CustomDropdown
                placeholder="Cliente"
                label={<ErrorLabel label="Cliente" error={error} />}
                selection
                width={width}
                loading={loading}
                options={options}
                value={value}
                onChange={onChange}
                error={error ? true : false}
            />
        );
    }
}

DropdownClient.defaultProps = {
    showSalvus: false,
    filter: [CLIENT_STATUS.ENABLED],
};

DropdownClient.propTypes = {
    width: PropTypes.number.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func,
    showSalvus: PropTypes.bool,
    filter: PropTypes.array,
    error: PropTypes.string,
};

export default DropdownClient;
